import { render } from "./NavigationProfile.vue?vue&type=template&id=57d2d87e&scoped=true&ts=true&lang=pug"
import script from "./NavigationProfile.vue?vue&type=script&lang=ts"
export * from "./NavigationProfile.vue?vue&type=script&lang=ts"

import "./NavigationProfile.vue?vue&type=style&index=0&id=57d2d87e&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./NavigationProfile.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/navigation/navigationList.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fcomponents%2Fnavigation%2FNavigationProfile.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d2d87e"]])

export default __exports__